// extracted by mini-css-extract-plugin
export default {"cls1":"Lightbox-Dialog-module--cls1--KLj8G","cls2":"Lightbox-Dialog-module--cls2--xRpg0 Lightbox-Dialog-module--cls1--KLj8G"};